import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useProfileCompletionData } from "./use-profile-completion-data";
import { ProfileStep } from "./ProfileStep";
import { ArchetypeStep } from "./ArchetypeStep";
import { GuildStep } from "./GuildStep";
import { ValueRevealStep } from "./ValueRevealStep";
import type { ProfileCompletionDialogProps } from "./types";

export const PREVENT_ACCIDENTAL_CLOSE = true;

export function ProfileCompletionDialog({ externalOpen, onClose }: ProfileCompletionDialogProps = {}) {
  const data = useProfileCompletionData({ externalOpen, onClose });

  if (!data.isAuthenticated || !data.user) return null;

  const dialogWidth =
    data.step === "archetype" || data.step === "guild"
      ? "sm:max-w-lg"
      : "sm:max-w-md";

  return (
    <Dialog
      open={data.open}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          data.handleClose();
        } else {
          data.setOpen(true);
        }
      }}
    >
      <DialogContent
        className={`${dialogWidth} max-h-[90vh] overflow-y-auto`}
        onPointerDownOutside={() => data.handleClose()}
        onEscapeKeyDown={() => data.handleClose()}
      >
        {data.step === "profile" ? (
          <ProfileStep
            preferredName={data.preferredName}
            onPreferredNameChange={data.setPreferredName}
            gender={data.gender}
            onGenderChange={data.setGender}
            dateOfBirth={data.dateOfBirth}
            onDateOfBirthChange={data.setDateOfBirth}
            onSave={data.handleSave}
            onSkip={data.handleClose}
            savePending={data.saveMutation.isPending}
          />
        ) : data.step === "guild" ? (
          <GuildStep
            onSelectGuild={(guild) => data.guildMutation.mutate(guild)}
            onSkip={data.handleGuildSkip}
            isPending={data.guildMutation.isPending}
          />
        ) : data.step === "valueReveal" ? (
          <ValueRevealStep onDone={data.handleValueRevealDone} />
        ) : (
          <ArchetypeStep
            onSelectArchetype={(profile) => data.archetypeMutation.mutate(profile)}
            onSkip={data.handleClose}
            isPending={data.archetypeMutation.isPending}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
